import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  CERTIFICA_EMAIL,
  CERTIFICA_EMAIL_FAIL,
  CERTIFICA_EMAIL_SUCCESS,
  CERTIFICA_OTP,
  CERTIFICA_OTP_SUCCESS,
  CERTIFICA_OTP_FAIL,
} from './certifica-email.actions';
import { mergeMap, catchError, of, tap } from 'rxjs';
import { ApiService} from '../../services/api.service';
import { IResponseCertificaEmail } from '../../interfaces/certifica-email';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ADD_MESSAGE } from '../messages/messages.actions';

@Injectable()
export class CertificaEmailEffects {
  submitEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CERTIFICA_EMAIL),
      mergeMap(({ body }) =>
        this.api.certificaEmail(body).pipe(
          mergeMap((response: IResponseCertificaEmail) => [
            CERTIFICA_EMAIL_SUCCESS({
              esito: response.esito,
              seed: response.seed!,
              email: body.email,
              msgCode: response.msgCode,
              otpTtlSeconds: response.otpTtlSeconds,
              otpTtlSecondsEmail: response.otpTtlSecondsEmail,
              coolDownOTP: response.coolDownOTP,
              maxTentativi: response.maxTentativi
            })
          ])
          ,
          catchError((error) => {
            this.store.dispatch(ADD_MESSAGE({ message: error?.message || 'Errore certificazione e-mail' }));
            return of(CERTIFICA_EMAIL_FAIL({ error }));
          })
        )
      )
    )
  );

  submitOtp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CERTIFICA_OTP),
      mergeMap(({ otp, seed, username, telefono_certificato }) =>
        this.api.verificaOtp({
          otp,
          seed,
          username,
          telefono_certificato
        }).pipe(
          mergeMap(response => [
            CERTIFICA_OTP_SUCCESS({
              esito: response.esito,
              msgCode: response.msgCode,
              username: response.username
            })
          ]),
          catchError(error => {
            this.store.dispatch(
              ADD_MESSAGE({
                message: error?.message ?? 'Errore verifica OTP'
              })
            );
            return of(CERTIFICA_OTP_FAIL({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private store: Store,
    private router: Router
  ) {}
}
